export const C = {
  bg:         '#F5F2E9',
  surface:    '#FEFCF6',
  teal:       '#004D40',
  tealDark:   '#003430',
  tealMid:    'rgba(0,77,64,0.09)',
  amber:      '#FFBC00',
  amberDim:   'rgba(255,188,0,0.18)',
  text:       '#1C1A16',
  textMuted:  '#7D776F',
  textDim:    'rgba(28,26,22,0.36)',
  border:     'rgba(0,0,0,0.08)',
  borderMid:  'rgba(0,0,0,0.11)',
  shadow:     '0 2px 10px rgba(0,0,0,0.07), 0 1px 3px rgba(0,0,0,0.04)',
  shadowHero: '0 10px 36px rgba(0,77,64,0.28), 0 3px 10px rgba(0,77,64,0.16)',
  shadowCard: '0 8px 32px rgba(0,0,0,0.10), 0 2px 8px rgba(0,0,0,0.06)',
  body:       "'Inter', -apple-system, system-ui, sans-serif",
  display:    "'DM Serif Display', Georgia, serif",
};
